export default {
  data : function () {
    return {
      path: {
        HTTP : 'https://api.mf-t.ru/v3/',
        HTTP_AUTH : 'https://auth.mf-t.ru/v1/',
        HTTP_COMM : 'https://api.mf-t.ru/',
        socket : 'wss://ws.mf-t.ru/state/',
        /*socket : 'ws://192.168.105.11:8080/state'*/
      },
      pathDev: {
        HTTP : 'https://api.dev.mf-t.ru/v3/',
        HTTP_AUTH : 'https://auth.dev.mf-t.ru/v1/',
        HTTP_COMM : 'https://api.dev.mf-t.ru/',
        socket : 'wss://ws.dev.mf-t.ru/state/',
        /*socket : 'ws://192.168.105.11:8080/state'*/
      }
    }
  }
}